import { useTheme } from '@material-ui/core/styles';
import colors from 'constants/colors';
import isNumber from 'lodash/isNumber';
import pullAt from 'lodash/pullAt';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import PropTypes from 'prop-types';

const datasetAttributes = {
  label: 'Percentage In Class',
  backgroundColor: colors,
  borderColor: '#477DD9',
};

RosterGraph.propTypes = {
  meetingData: PropTypes.object.isRequired,
};
export default function RosterGraph(props) {
  const { meetingData } = props;
  const theme = useTheme();

  const [height, setHeight] = useState('300px');

  const [data, setData] = useState({
    labels: [],
    scale: { gridLines: { display: false } },
    datasets: [
      {
        ...datasetAttributes,
        data: [],
      },
    ],
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: true,
      position: 'top',
      fontSize: '24',
      fontColor: theme.palette.primary.main,
      text: 'Roster',
    },
    scales: {
      xAxes: [
        {
          ticks: {
            max: 100,
            min: 0,
            stepSize: 10,
          },
        },
      ],
    },
  };

  useEffect(() => {
    const timeDiffInMs = (start, finish) => {
      start = isNumber(start) ? start : parseInt(start);
      finish = isNumber(finish) ? finish : parseInt(finish);
      return moment(finish).diff(moment(start), 'milliseconds');
    };
    const { meeting, attendees } = meetingData;
    if (!meeting || !attendees) return;

    const totalMeetingTime = timeDiffInMs(meeting.StartDate, meeting.EndDate);
    const labels = [];
    const newData = [];
    attendees.forEach((attendee) => {
      let totalMS = 0;
      let i = 0;
      while (attendee.AttendenceTimes?.[i]) {
        const item = attendee.AttendenceTimes[i].split('#');
        let next = attendee.AttendenceTimes?.[i + 1]?.split('#');
        let nextType = next?.[0];
        while (nextType && nextType === 'Enter') {
          pullAt(attendee.AttendenceTimes, [i + 1]);
          next = attendee.AttendenceTimes?.[i + 1]?.split('#');
          nextType = next?.[0];
        }
        if (item?.[1] && next?.[1]) {
          totalMS += timeDiffInMs(item[1], next[1]);
        }

        i += 2;
      }
      let attendencePercentage = Math.round((totalMS / totalMeetingTime) * 100);
      attendencePercentage = attendencePercentage > 100 ? 100 : attendencePercentage;
      labels.push(attendee.Name);
      newData.push(attendencePercentage);
    });

    setHeight(`${150 + attendees.length * 25}px`);

    setData((stateData) => ({
      ...stateData,
      labels,
      datasets: [
        {
          ...datasetAttributes,
          data: newData,
        },
      ],
    }));
  }, [meetingData]);

  return (
    <div style={{ height: height }} data-testid="horiz-bar">
      <HorizontalBar data={data} options={options} />
    </div>
  );
}
